const MessageBox = ({ message, type = 'info' }) => {
  const style = {
    padding: '10px',
    margin: '10px 0',
    background: type === 'error' ? '#fdd' : type === 'success' ? '#9ad1bb' : '#eee',
    border: '1px solid',
    borderColor: type === 'error' ? '#d00' : type === 'success' ? '#107c6b' : '#ccc'
  }
  return <div style={style}>{message}</div>
}

export default MessageBox
